
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.507","height":"19.507"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M0 9.753a9.754 9.754 0 119.753 9.754A9.764 9.764 0 010 9.753zm1.5 0A8.253 8.253 0 109.753 1.5 8.263 8.263 0 001.5 9.753zm7.4 3.9a.85.85 0 011.671-.22l.023.12.006.1a.85.85 0 01-1.7 0zm.2-2.823a.75.75 0 01.2-.965l.085-.056 1.328-.737a1.327 1.327 0 00.689-1.122A1.561 1.561 0 009.855 6.5H9.7a1.6 1.6 0 00-1.617 1.235.75.75 0 11-1.461-.335A3.071 3.071 0 019.693 5a3.057 3.057 0 013.212 2.9 2.836 2.836 0 01-1.3 2.38l-.165.1-1.327.737A.749.749 0 019.1 10.83z","fill":"#011936"}})])
          )
        }
      }
    